/* Boo & Breeze measurement v1. Standard ecommerce remains owned by official app pixels. */
(() => {
  'use strict';
  if (window.BBAnalytics) return;
  let config;
  try { config = JSON.parse(document.getElementById('bb-analytics-config').textContent); } catch { return; }
  if (config.enabled === false) return;
  const query = new URLSearchParams(location.search);
  let decodedPath;
  try { decodedPath = decodeURIComponent(location.pathname); } catch { decodedPath = '/authentication'; }
  const sensitive = /\/(?:accounts?|checkouts?|orders|authentication)(?:\/|$)/i.test(decodedPath) || /[@?#\\\u0000-\u001f]/.test(decodedPath);
  const editor = Boolean(window.Shopify?.designMode);
  const preview = config.theme_role !== 'main' || editor || query.has('preview_theme_id');
  const qa = query.get('bb_analytics_debug') === '1';
  const forcedTest = query.get('bb_analytics_test') === '1';
  let testSession = preview || forcedTest || qa;
  let initialPermission = false;
  try { initialPermission = window.Shopify?.customerPrivacy?.analyticsProcessingAllowed() === true; } catch {}
  let consent = false, active = false, sequence = 0, localeReady = false, epoch = 0, flushTimer, googleTimer;
  const seen = new Set(), pending = [], googlePending = [], timers = new Map(), ratios = new Map();
  const counts = { published: 0, rejected: 0, failed: 0, googleQueued: 0, googleDropped: 0, googleFailed: 0 };
  const names = new Set(['page_context','section_view','bundle_select','add_attempt','add_result','cart_change','cart_result','checkout_click','upsell_click','image_select','cta_click','faq_open','language_change','contact_result','contact_submit','scroll_depth','reading_time','sound_invite','sound_click','sound_state','sound_listen','web_vital','script_error']);
  const numeric = new Set(['quantity','previous_quantity','value','duration_ms','percent','position','metric_value','http_status']);
  const identifiers = new Set(['component','action','bundle_mode','product_id','variant_id','destination_path','question_id','source','reason','result','metric_name','metric_id','language_to','currency','error_code']);
  function allowed() {
    try { return localeReady && !sensitive && window.Shopify?.customerPrivacy?.analyticsProcessingAllowed() === true; } catch { return false; }
  }
  function clean(input = {}) {
    const output = {};
    for (const [key, value] of Object.entries(input || {})) {
      if (numeric.has(key) && typeof value === 'number' && Number.isFinite(value)) output[key] = Math.max(-1e6, Math.min(1e9, value));
      else if (identifiers.has(key) && ['number','string'].includes(typeof value) && /^[a-z0-9_:.\/-]{1,160}$/i.test(String(value))) output[key] = String(value);
    }
    return output;
  }
  function testMode() {
    // Latch this page once marked; keep the marker in this tab after consent.
    // A URL flag must not reclassify the later events of a test visit as production.
    // This marks only our custom events; official events need their own filter.
    try { testSession ||= sessionStorage.getItem('bb-analytics-test') === '1'; } catch {}
    return testSession;
  }
  function publicPath(value) {
    if (typeof value !== 'string' || value.length > 240) return;
    let path; try { path = decodeURIComponent(value); } catch { return; }
    if (/[%@?#\\\u0000-\u001f]/.test(path)) return;
    if (!/^\/(?:[a-z]{2}(?:-[a-z]{2,4})?\/)?(?:(?:products|collections|pages|policies)\/[a-z0-9-]{1,100}|blogs\/[a-z0-9-]{1,80}(?:\/[a-z0-9-]{1,100})?|cart)?\/?$/i.test(path)) return;
    return path;
  }
  function sendGoogle(item) {
    // The official OPEN pixel owns the existing gtag, SDK, identity and consent.
    // This branch only sends custom events; it never loads or configures a tag.
    if (item.googleAttempted) return;
    const path = publicPath(item.data.page_path);
    if (!/^G-[A-Z0-9]+$/.test(config.ga4_measurement_id || '') || !path || !publicPath(location.pathname) || editor || !allowed() || !consent || item.epoch !== epoch || Date.now() - item.at >= 5000) {
      counts.googleDropped += 1; return;
    }
    if (typeof window.gtag !== 'function') {
      if (googlePending.length < 30) googlePending.push(item); else counts.googleDropped += 1;
      if (!googleTimer) googleTimer = setTimeout(() => { googleTimer = undefined; googlePending.splice(0).forEach(sendGoogle); }, 250);
      return;
    }
    const data = clean(item.data);
    // Keep interaction origins separate from Google's campaign source field.
    // The Shopify event contract retains source for existing local subscribers.
    if (data.source) data.bb_interaction_source = data.source;
    delete data.source;
    for (const key of ['event_id','schema_version','release','theme_id','page_type','locale']) {
      const value = item.data[key];
      if (typeof value === 'string' && /^[a-z0-9_.:-]{1,160}$/i.test(value)) data[key] = value;
    }
    if (data.destination_path && !publicPath(data.destination_path)) delete data.destination_path;
    // A QA-marked item stays QA if the session marker changes while it waits.
    const isTest = item.data.environment !== 'production' || testMode();
    Object.assign(data, {page_path:path,environment:isTest?'test':'production',send_to:config.ga4_measurement_id,page_location:'https://booandbreeze.com'+path,page_referrer:'',page_title:''});
    // Keep the test-session marker available to session exclusion explorations.
    // Known staff IPs can still be classified by GA4's own internal-traffic rule.
    if (isTest && item.name !== 'page_context') Object.assign(data, {debug_mode:true,traffic_type:'internal'});
    item.googleAttempted = true;
    try { window.gtag('event','bb_'+item.name,data); counts.googleQueued += 1; }
    catch { counts.googleFailed += 1; } // A throw may follow enqueueing: never retry it.
  }
  function send(item) {
    if (!allowed() || !consent || item.epoch !== epoch) return;
    if (Date.now() - item.at >= 5000) { counts.failed += 1; return; }
    if (typeof window.Shopify?.analytics?.publish !== 'function') {
      if (pending.length < 30) pending.push(item); else counts.failed += 1;
      if (!flushTimer) flushTimer = setTimeout(() => { flushTimer = undefined; pending.splice(0).forEach(send); }, 250);
      return;
    }
    try {
      Promise.resolve(window.Shopify.analytics.publish('bb:' + item.name, item.data)).then(result => {
        if (result === false) counts.failed += 1; else counts.published += 1;
      }).catch(() => { counts.failed += 1; });
      // The consent-gated BBClarity loader owns the single official recorder.
      try { if (item.data.environment === 'production' && typeof window.clarity === 'function') window.clarity('event', 'bb_' + item.name); } catch { /* A recorder must not break the primary event channel. */ }
      if (qa) console.debug('[BB analytics]', item.name, item.data);
    } catch { counts.failed += 1; }
  }
  function track(name, input = {}, onceKey) {
    try {
    if (!names.has(name) || !allowed() || !consent || editor || (preview && !qa && name !== 'page_context') || (onceKey && seen.has(onceKey))) { counts.rejected += 1; return false; }
    if (onceKey) seen.add(onceKey);
    let eventId;
    try { eventId = window.crypto?.randomUUID?.(); } catch { /* Fall back when crypto is restricted. */ }
    eventId ||= `${Date.now()}-${++sequence}-${Math.random().toString(36).slice(2)}`;
    const data = { ...clean(input), event_id: eventId, schema_version: '1', release: config.release, theme_id: String(config.theme_id), page_type: config.page_type, page_path: location.pathname, locale: config.locale, environment: testMode() ? 'test' : 'production' };
    if (config.product_id) data.product_id ||= String(config.product_id);
    if (config.variant_id) data.variant_id ||= String(config.variant_id);
    const item = { name, data, at: Date.now(), epoch, onceKey };
    // Independent delivery: a missing/throwing publisher or tag cannot block the other.
    send(item);
    try { sendGoogle(item); } catch { counts.googleFailed += 1; }
    return true;
    } catch { counts.failed += 1; return false; }
  }
  const component = element => {
    const entry = element?.closest('[data-bb-measure],.bb-hero,.bb-bundle,.bb-product,.bb-cart-upsell,.bb-cart-summary,.bb-footer,.bb-header,.article-template,.bb-faq,[data-bb-sound]');
    if (entry?.dataset.bbMeasure) return entry.dataset.bbMeasure;
    return entry?.matches('[data-bb-sound]') ? 'sound' : [...(entry?.classList || [])].find(v => /^(bb-|article-template)/.test(v))?.replace(/^bb-/, '') || 'page';
  };
  let observer;
  function observe(scope = document) {
    const selector = '[data-bb-buy] .bb-options label,[data-bb-buy],[data-bb-sound],#our-story,#faq,.article-template,.bb-cart-upsell,.bb-cart-summary';
    const elements = [...scope.querySelectorAll(selector)];
    if (scope.matches?.(selector)) elements.unshift(scope);
    elements.forEach(element => {
      if (element.dataset.bbMeasured) return;
      element.dataset.bbMeasured = 'true';
      const bundle=element.querySelector('input[type=radio]');
      if(element.matches('label')&&bundle){element.dataset.bbMeasure='bundle-option';element.dataset.bbAnalyticsBundle=bundle.value;}
      observer?.observe(element);
    });
    ratios.forEach((_, element) => { if (!element.isConnected) { observer?.unobserve(element); clearTimeout(timers.get(element)); timers.delete(element); ratios.delete(element); } });
  }
  function clearExposureTimers() { timers.forEach(clearTimeout); timers.clear(); }
  function visibility() {
    if (document.hidden || !consent || !allowed()) { clearExposureTimers(); return; }
    ratios.forEach((ratio, element) => {
      if (ratio < 0.5 || !element.isConnected) { clearTimeout(timers.get(element)); timers.delete(element); return; }
      const key = 'exposure:' + component(element) + ':' + (element.dataset.bbAnalyticsBundle || element.id || 'default');
      if (!seen.has(key) && !timers.has(element)) timers.set(element, setTimeout(() => {
        timers.delete(element);
        if (!document.hidden && allowed() && element.isConnected && ratios.get(element) >= 0.5) track('section_view', { component: component(element), ...(element.dataset.bbAnalyticsBundle?{bundle_mode:element.dataset.bbAnalyticsBundle}:{}) }, key);
      }, 1000));
    });
  }
  let readingMs = 0, reportedReadingMs = 0, lastTick = performance.now(), wasVisible = !document.hidden;
  const audioTimes = new Map();
  function tick(visible = !document.hidden) {
    const now = performance.now(), delta = Math.min(now - lastTick, 2000); lastTick = now;
    if (!consent || !allowed()) return;
    audioTimes.forEach((time, audio) => {
      const media = Number(audio.currentTime), elapsed = Math.max(0, Math.min(now - time.at, 2000));
      const progressed = Number.isFinite(media) ? Math.max(0, media - time.media) * 1000 / Math.max(0.01, Number(audio.playbackRate) || 1) : 0;
      time.at = now; time.media = media;
      if (!visible || !time.active || audio.seeking || audio.muted || audio.volume <= 0) return;
      time.ms += Math.min(elapsed, progressed);
      [10000,30000,60000].forEach(ms => { if (time.ms >= ms) track('sound_listen', {duration_ms:ms,source:time.source}, 'listen:' + ms); });
    });
    if (!visible) return;
    readingMs += delta;
    [30000,60000,120000].forEach(ms => { if (readingMs >= ms) track('reading_time', {duration_ms: ms}, 'reading:' + ms); });
  }
  function updateConsent() {
    try { if (window.Shopify?.customerPrivacy?.analyticsProcessingAllowed() !== true) initialPermission = false; } catch { initialPermission = false; }
    const next = allowed();
    if (consent === next) return;
    consent = next; epoch += 1; lastTick = performance.now(); wasVisible = !document.hidden;
    if (!next) {
      // Exposure is once per page, even across consent changes. Only release
      // reservations that reached neither delivery channel; do not replay sent views.
      pending.forEach(item => { if (item.onceKey?.startsWith('exposure:') && !item.googleAttempted) seen.delete(item.onceKey); });
      pending.length = 0; clearTimeout(flushTimer); flushTimer = undefined;
      counts.googleDropped += googlePending.length; googlePending.length = 0; clearTimeout(googleTimer); googleTimer = undefined;
      readingMs = 0; reportedReadingMs = 0; audioTimes.clear();
      seen.forEach(key => { if (!key.startsWith('exposure:')) seen.delete(key); });
      clearExposureTimers();
      document.querySelectorAll('[data-bb-sound]').forEach(root => { delete root.dataset.bbAnalyticsSoundSource; delete root.dataset.bbAnalyticsSoundState; });
      return;
    }
    try { if (testMode()) sessionStorage.setItem('bb-analytics-test','1'); } catch {}
    if (!active) start();
    track('page_context', {}, 'page_context');
    document.querySelectorAll('[data-bb-sound-audio]').forEach(audio => { if (!audio.paused && !audio.ended) playing(audio, 'current'); });
    if (document.querySelector('[data-bb-sound-invite][open]')) track('sound_invite',{component:'sound',action:'shown'});
    visibility();
  }
  function soundState(root, session) {
    if (!consent || !allowed()) return;
    if (root.dataset.bbAnalyticsSoundState === session.state) return;
    root.dataset.bbAnalyticsSoundState = session.state;
    if (session.state === 'playing') return;
    track('sound_state', { component:'sound', result:session.state, source:root.dataset.bbAnalyticsSoundSource || 'auto' });
  }
  function playing(audio, currentSource) {
    if (!consent || !allowed()) return;
    const source = currentSource || audio.closest('[data-bb-sound]')?.dataset.bbAnalyticsSoundSource || 'auto';
    let time = audioTimes.get(audio);
    if (!time) { time = {ms:0,reportedMs:0,reportedPlaying:false}; audioTimes.set(audio,time); }
    Object.assign(time,{source,media:Number(audio.currentTime),at:performance.now(),active:true});
    if (!time.reportedPlaying) track('sound_state',{component:'sound',result:'playing',source});
    time.reportedPlaying = true;
  }
  function start() {
    active = true;
    if ('IntersectionObserver' in window) observer = new IntersectionObserver(entries => {
      entries.forEach(entry => ratios.set(entry.target, entry.intersectionRatio)); visibility();
    }, {threshold:[0,0.5,1]});
    observe();
    document.addEventListener('shopify:section:load', e => observe(e.target));
    document.addEventListener('bb:cart-settled', () => observe());
    document.addEventListener('visibilitychange', () => { tick(wasVisible); wasVisible = !document.hidden; visibility(); });
    let scrolling = false;
    window.addEventListener('scroll', () => {
      if (scrolling) return; scrolling = true;
      requestAnimationFrame(() => {
        scrolling = false;
        if (document.hidden) return;
        const height = Math.max(document.documentElement.scrollHeight, document.body.scrollHeight);
        const percent = Math.min(100, (window.scrollY + window.innerHeight) / Math.max(1,height) * 100);
        [25,50,75,90].forEach(value => { if (percent >= value) track('scroll_depth',{percent:value},'scroll:'+value); });
      });
    },{passive:true});
    document.addEventListener('click', e => {
      if (!consent || !allowed()) return;
      const element = e.target.closest?.('a,button,audio'); if (!element) return;
      const sound = element.closest('[data-bb-sound]');
      if (sound) {
        const source = element.matches('[data-bb-sound-listen]') ? 'invitation' : element.closest('[data-bb-sound-mini]') ? 'mini' : element.matches('audio') ? 'native' : 'inline';
        sound.dataset.bbAnalyticsSoundSource = source;
        if (element.matches('[data-bb-sound-listen],[data-bb-sound-toggle],audio')) track('sound_click',{component:'sound',source});
        if (element.matches('[data-bb-sound-listen]')) track('sound_invite',{component:'sound',action:'accept',source:'invitation'});
        if (element.matches('[data-bb-sound-dismiss]')) track('sound_invite',{component:'sound',action:'dismiss',source:element.matches('.bb-sound-invite-close')?'close':'quiet'});
      }
      if (element.matches('[data-bb-checkout]')) track('checkout_click',{component:'cart'});
      if (element.matches('[data-bb-upsell-add]')) track('upsell_click',{component:'cart-upsell'});
      if (!element.matches('a[href]')) return;
      const href = element.getAttribute('href');
      if (/^(mailto:|tel:)/.test(href)) { track('cta_click',{component:component(element),action:href.startsWith('mailto:')?'email':'phone'}); return; }
      try {
        const url = new URL(href,location.origin);
        if (url.origin !== location.origin || /\/(?:account|orders|checkouts?)(?:\/|$)/.test(url.pathname)) return;
        const action = /\/products\//.test(url.pathname)?'product':/\/blogs\//.test(url.pathname)?'guide':/\/pages\/(shipping|returns|contact|about|track-order)/.test(url.pathname)?url.pathname.split('/').pop():href.startsWith('#')?'anchor':'navigation';
        track('cta_click',{component:component(element),action,destination_path:url.pathname});
      } catch {}
    },true);
    document.addEventListener('keydown',e=>{if(e.key==='Escape'&&document.querySelector('[data-bb-sound-invite][open]'))track('sound_invite',{component:'sound',action:'dismiss',source:'escape'});},true);
    document.addEventListener('toggle', e => {
      const element = e.target;
      if (element.matches?.('[data-bb-sound-invite]') && element.open) track('sound_invite',{component:'sound',action:'shown'});
      if (element.matches?.('.bb-faq-list details,[data-bb-other-sets]') && element.open) {
        const index = [...element.parentElement.querySelectorAll('details')].indexOf(element) + 1;
        track('faq_open',{component:component(element),question_id:element.dataset.bbQuestion || 'item-'+index});
      }
    },true);
    document.addEventListener('playing', e => {
      if (!e.target.matches?.('[data-bb-sound-audio]')) return;
      playing(e.target);
    },true);
    ['pause','ended','waiting','seeking','volumechange'].forEach(name => document.addEventListener(name, e => {
      const time = audioTimes.get(e.target); if (!time) return;
      tick();
      if (['pause','ended','waiting','seeking'].includes(name)) time.active = false;
      if (name === 'pause' || name === 'ended') time.reportedPlaying = false;
    },true));
    document.addEventListener('submit',e=>{if(e.target.matches?.('.bb-contact-form'))track('contact_submit',{component:'contact'});},true);
    if (document.querySelector('.bb-contact-form [data-bb-contact-success]')) track('contact_result',{component:'contact',result:'success'},'contact_result');
    else if(document.querySelector('.bb-contact-form .errors')) track('contact_result',{component:'contact',result:'validation_error'},'contact_result');
    window.addEventListener('error',e=>{if(e.filename && /\/bb-[a-z-]+\.js(?:\?|$)/.test(e.filename))track('script_error',{error_code:'theme_script'});});
    setInterval(tick,1000);
    window.addEventListener('pagehide',()=>{
      tick(wasVisible);
      if (readingMs > reportedReadingMs) track('reading_time',{duration_ms:Math.round(readingMs-reportedReadingMs),action:'page_end'});
      reportedReadingMs=readingMs;
      audioTimes.forEach(time=>{if(time.ms>time.reportedMs)track('sound_listen',{duration_ms:Math.round(time.ms-time.reportedMs),source:time.source,action:'page_end'});time.reportedMs=time.ms;});
      clearExposureTimers(); wasVisible = false;
    });
    window.addEventListener('pageshow',()=>{lastTick=performance.now();wasVisible=!document.hidden;audioTimes.forEach((time,audio)=>{time.at=lastTick;time.media=Number(audio.currentTime);});visibility();});
    if (config.vitals_url) {
      const vitalsEpoch = epoch, vitalsSince = initialPermission ? 0 : performance.now();
      import(config.vitals_url).then(vitals=>{
        if (!consent || !allowed() || epoch !== vitalsEpoch) return;
        const record = metric => {
          // web-vitals aggregates buffered, page-lifetime entries and exposes no
          // reset/dispose API. After withdrawal this page's observers stay inert,
          // including after re-grant; a new page load starts a fresh collection.
          if (!consent || !allowed() || epoch !== vitalsEpoch) return;
          const entries = metric.entries || [];
          if (vitalsSince > 0 && (!entries.length || entries.some(entry => !Number.isFinite(entry.startTime) || entry.startTime < vitalsSince))) return;
          track('web_vital',{metric_name:metric.name.toLowerCase(),metric_value:metric.value,metric_id:metric.id},'vital:'+metric.id);
        };
        vitals.onCLS(record);vitals.onINP(record);vitals.onLCP(record);
      }).catch(()=>{});
    }
  }
  window.BBAnalytics = { track, clean, allowed, soundState, status:()=>({...counts,pending:pending.length,googlePending:googlePending.length,consent,environment:testMode()?'test':'production'}) };
  document.addEventListener('visitorConsentCollected',updateConsent);
  let retries=0;
  const ready=setInterval(()=>{
    updateConsent();
    if(++retries>=40)clearInterval(ready);
  },250);
  try { window.Shopify?.loadFeatures?.([{name:'consent-tracking-api',version:'0.2'}],error=>{if(!error)updateConsent();}); } catch {}
  Promise.resolve(window.bbLocaleReady).then(result=>{localeReady=!result?.redirecting;if(localeReady)updateConsent();}).catch(()=>{});
})();
